import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { find, isUndefined } from "lodash"
import ReactTooltip from "react-tooltip"
import { Link } from "react-router-dom"

import { createUrlForSeveralParcels } from "shared/utils"
import { GET_PARCEL } from "data/constants"
import { clearParcel } from "data/actions/parcel"
import { clearParcels } from "data/actions/parcels"

import Panel from "shared/components/Panel"
import Loader from "shared/components/Loader/Local"

import Faq from "../Faq"

import ParcelsSwitcher from "./components/ParcelsSwitcher"
import CovidBanner from "./components/CovidBanner"
import DeliveryProgress from "./components/DeliveryProgress"
import Information from "./components/Information"
import HistoryComponent from "./components/History"
import NoParcel from "./components/NoParcel"

class Parcel extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    state: PropTypes.oneOf(["INITIAL", "LOADING", "LOADED", "FAILED"]).isRequired,
    data: PropTypes.object,
    parcels: PropTypes.object,
    error: PropTypes.object,
    get: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    clearAll: PropTypes.func.isRequired,
  }
  static defaultProps = {
    data: null,
    parcels: null,
    error: null,
  }
  static contextTypes = {
    t: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props)

    this.backUrl = createUrlForSeveralParcels(props.parcels.list)
  }

  componentDidMount() {
    this.fetch()
  }

  componentWillUpdate(nextProps) {
    const { clear, clearAll, data, state, parcels, match } = this.props

    if (
      nextProps.match.params.id !== match.params.id
    ) {
      if (state === "LOADED") {
        const parcelInParcels = find(parcels.list, {
          tracking_number: data.tracking_number,
        })
        // clear parcels list anytime single parcel is being searched and the list was searched previously
        // it will prevent ParcelsViewSwitcher component to be rendered when single parcel is being requested
        if (!parcelInParcels) {
          clearAll()
        }
      }

      clear()
    }
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props

    if (prevProps.match.params.id !== match.params.id) {
      this.fetch()
    }
    ReactTooltip.rebuild()
  }

  fetch() {
    const { get, match } = this.props
    get(match.params.id)
  }

  renderParcelsSwitchers() {
    const { data, parcels } = this.props
    const { t: translate } = this.context

    return parcels.count > 1 && (
      <div className="m-b-15">
        <div className="row">
          <div className="col-xs-6">
            <Link className="block m-t-10" to={this.backUrl}>
              <i className="zmdi zmdi-chevron-left fs-20 v-m"></i>
              {" "}
              {translate("Go back")}
            </Link>
          </div>
          <div className="col-xs-6 textRight">
            <ParcelsSwitcher
              list={parcels.list}
              current={data}
            />
          </div>
        </div>
      </div>
    )
  }

  renderParcel() {
    const { data: parcel } = this.props
    const { t: translate } = this.context

    return (
      <Fragment>
        {this.renderParcelsSwitchers()}
        <CovidBanner />
        <DeliveryProgress
          status={parcel.delivery_progress}
          orderDate={parcel.shipment.order_date}
          deliveryDays={parcel.shipment.delivery_business_days}
          deliveryDates={parcel.shipment.delivery_dates}
        />
        <Information
          parcel={parcel}
        />
        <Panel className="m-b-20">
          <h2 className="w400 fs-12">{translate("History")}</h2>
          {parcel.last_mile_history && parcel.last_mile_history.length > 0 && (
            <HistoryComponent
              awaitingUpdateMessage={parcel.awaiting_update_message}
              title={
                parcel.last_mile_courier_info ?
                  translate("{courier} tracking history", {
                    courier: parcel.last_mile_courier_info.courier,
                  }) :
                  translate("Domestic tracking history")
              }
              history={parcel.last_mile_history}
              help={translate("Local tracking details updated by final mile carrier in destination country")}
            />
          )}
          <HistoryComponent
            awaitingUpdateMessage={parcel.last_mile_history.length ? null : parcel.awaiting_update_message}
            title={parcel.last_mile_courier_info && translate("International carrier tracking history")}
            history={
              parcel.domestic_history ?
                parcel.history.concat(parcel.domestic_history) :
                parcel.history
            }
            help={translate("Full international shipping history from country of origin to final delivery")}
          />
        </Panel>
        <div id="faq">
          <Faq />
        </div>
      </Fragment>
    )
  }

  renderError() {
    const { error, match } = this.props
    if (error.message === "NOT_FOUND" && !isUndefined(match.params.id)) {
      return <NoParcel trackingNumber={match.params.id} />
    }
    return <NoParcel />
  }

  render() {
    const { state } = this.props

    switch (state) {
      case "LOADING":
        return <Loader />
      case "LOADED":
        return this.renderParcel()
      case "FAILED":
        return this.renderError()
      case "INITIAL":
      default:
        return null
    }
  }
}

const mapStateToProps = state => ({
  ...state.parcel,
  parcels: state.parcels,
})

const mapDispatchToProps = dispatch => ({
  get: number => dispatch({
    type: GET_PARCEL,
    number,
  }),
  clear: () => dispatch(clearParcel()),
  clearAll: () => dispatch(clearParcels()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Parcel)



// WEBPACK FOOTER //
// ./src/views/Parcel/Parcel.js